<template>
  <b-col md="12" sm="12">
    <b-card no-body class="mx-4">
      <b-card-body class="p-12">
        <h1>REGIMENTO INTERNO</h1>
      </b-card-body>
    </b-card>
    <b-card no-body class="mx-4">
      <b-card-body class="p-8">
        <b-row>
          <b-col cols="12">
            <h3>Consulta Pública ao {{ form.titulo }}</h3>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div v-html="form.descricao"></div>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer class="p-12">
        <b-row>
          <b-col md="4">
            <b-button block variant="secondary" @click="visualizarRegimentoAtivo()">
              <i class="fa fa-search"></i>&nbsp;
              <span>Acessar Regimento</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-col>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import VueSelect from 'vue-select'
import {validationMixin} from 'vuelidate'
import {required} from 'vuelidate/lib/validators'
import miniToastr from 'mini-toastr'
import Multiselect from 'vue-multiselect'

miniToastr.init()

export default {
  name: 'Cadastro',
  components: {
    Pagination,
    VueSelect,
    Multiselect
  },
  mixins: [validationMixin],
  validations: {
    form: {
      titulo: {
        required
      },
      descricao: {
        required
      }
    }
  },
  created () {
    this.loadRegimento()
  },
  data () {
    return {
      loading: false,
      form: {
        titulo: '',
        descricao: ''
      },
      regimentoAtivo: null,
      resourceSugestao: '',
      resourceComentario: '',
      modalSugestaoEdicao: false,
      modalSugestaoExclusao: false,
      modalComentario: false,
      disable_buttons: false,
      titulo_toast: 'Alerta!',
      salvarForm: false
    }
  },
  computed: {
    edicoes () {
      return this.$store.state.pagination.getList
    },
    exclusoes () {
      return this.$store.state.pagination.getList
    },
    comentarios () {
      return this.$store.state.pagination.getList
    },
    isValid () {
      return !this.$v.form.$anyError
    },
    isValidSelection () {
      return this.selected !== '' && this.selected !== 'forbidden value'
    }
  },
  methods: {
    visualizarRegimentoAtivo () {
      this.navigate('/regimento/contribuir/' + this.regimentoAtivo)
    },
    loadModalSugestaoEdicao (artigo) {
      this.resourceSugestao = 'regimento/' + artigo + '/sugestao'
      this.modalSugestaoEdicao = true
      this.$store.dispatch('getRegistrosSearch', {resource: this.resourceSugestao, limit: 5, filtros: {tipo: 'A'}})
    },
    loadModalSugestaoExclusao (artigo) {
      this.resourceSugestao = 'regimento/' + artigo + '/sugestao'
      this.modalSugestaoExclusao = true
      this.$store.dispatch('getRegistrosSearch', {resource: this.resourceSugestao, limit: 5, filtros: {tipo: 'E'}})
    },
    loadModalComentarios (artigo) {
      this.resourceComentario = 'regimento/' + artigo + '/comentario'
      this.modalComentario = true
      this.$store.dispatch('getRegistrosSearch', {resource: this.resourceComentario, limit: 5})
    },
    loadRegimento (id) {
      Vue.http.get('api/regimento/ativo').then(response => {
        let data = response.body.data
        this.form.titulo = data.titulo
        this.form.descricao = data.descricao
        this.regimentoAtivo = data.id
      })
    },
    adicionarArtigo () {
      this.form.artigos.push({
        id: null,
        texto: ''
      })
    },
    removerArtigo (key) {
      this.form.artigos.splice(key, 1)
    },
    salvar () {
      let form = this.$v.form
      let data = {
        titulo: form.titulo.$model,
        descricao: form.descricao.$model,
        artigos: this.form.artigos
      }
      this.loading = true

      Vue.http.post('api/regimento', data).then(response => {
        if (response.body.success) {
          miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
          miniToastr.success(response.body.msg, 'Sucesso!', 7000)
          this.$router.push({path: '/'})
        } else {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-warning'})
          miniToastr.error(response.body.msg, 'Alerta', 5000)
        }
        this.loading = false
      }).catch(e => {
        console.log('Servidor está fora! ' + e)
      })
    },
    confirmar () {
      this.$bvModal.msgBoxConfirm('Tem certeza que deseja continuar?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          this.salvar()
        }
      }).catch(erro => {
        console.log(erro)
      })
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    onSubmit () {
      this.salvarForm = true
      if (this.validate()) {
        this.confirmar()
      }
    },
    chkState (val) {
      const field = this.$v.form[val]
      if (!field.$model && !this.salvarForm) {
        return null
      }

      return !field.$dirty || !field.$invalid
    },
    findFirstError (component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate () {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="vue-wysiwyg/dist/vueWysiwyg.css"></style>



// WEBPACK FOOTER //
// src/pages/site/interna/regimento/RegimentoEntrada.vue